import { BladeDamagesRepository } from "@/api/Repositories";
import { UsedSparePartsRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then(response => {
            const data = response.data.data.used_spare_part
            for (let i = 0; i < data.length; i++) {
              const element = data[i]
              element.option = element.spare_part_type_id
            }
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        UsedSparePartsRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {
      return new Promise((resolve, reject) => {
        UsedSparePartsRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        UsedSparePartsRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
